import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import theme from "../../theme/theme";
import MessageCard from "./components/MessageCard";
import { MessageMenuICON, NewMessageICON } from "../../assets/icons";
import MessageSearchBar from "./components/MessageSearchBar";
import i18n from "../../i18n-config";
import MessageWriteBar from "./components/MessageWriteBar";
import MessageChatCard from "./components/MessageChatCard";
import MessageDetailCard from "./components/MessageDetailCard";
import { ConfirmDialog, CustomPopper } from "../../components";
import { useState } from "react";

function Message() {
  const [show, setShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleShowOpen = () => setShow((prev) => !prev);

  const closeDeleteModal = () => {
    setDeleteModal(false);
  };

  return (
    <Box
      sx={{ height: "93vh", backgroundColor: "#F7F7F7", overflow: "hidden" }}
    >
      <Grid container sx={{ height: "100%" }}>
        <Grid
          item
          xs={5}
          p={2}
          sx={{ height: "100%", width: "100%", position: "relative" }}
        >
          <Box mb={3}>
            <Typography fontWeight={550} fontSize={25} mb={2}>
              Messages
            </Typography>
            <Stack direction="row" spacing={2} sx={{height: 50}} alignItems="center">
              <CustomPopper
                icon={
                  <IconButton
                    sx={{ backgroundColor: "#B5BAB540", width: 45, height: 45 }}
                  >
                    <MessageMenuICON />
                  </IconButton>
                }
                buttonStyle={{width: 45, height: 45, borderRadius: 100}}
                containerStyle={{ height: "200px", backgroundColor: "#E7FFE7"}}
                onClose={handleShowOpen}
              >
                <Stack
                  sx={{ width: "250px", height: "200px" }}
                >
                  <Typography color="#3D423F" sx={{cursor: "pointer"}} fontWeight={500} mb={2}>
                    {i18n.t("afficher_message_nonlu")}
                  </Typography>
                  <Typography color="#3D423F" sx={{cursor: "pointer"}} fontWeight={500} mb={2}>
                    {i18n.t("tout_marquer")}
                  </Typography>
                  <Typography color="#3D423F" sx={{cursor: "pointer"}} fontWeight={500} mb={2}>
                    {i18n.t("tout_marquer_non")}
                  </Typography>
                  <Typography color="#EF2E2E" sx={{cursor: "pointer"}} fontWeight={500} mb={2}>
                    {i18n.t("supprimer")}
                  </Typography>
                </Stack>
              </CustomPopper>
              <MessageSearchBar
                placeholder={i18n.t("rechercher_conversation")}
              />
            </Stack>
          </Box>
          <MessageCard />
          <MessageCard />
          <MessageCard />

          <IconButton
            sx={{
              backgroundColor: theme.colors.primary,
              width: 48,
              height: 48,
              position: "absolute",
              bottom: 25,
              right: 25,
            }}
          >
            <NewMessageICON />
          </IconButton>
        </Grid>
        <Grid
          item
          xs={7}
          sx={{
            backgroundColor: theme.colors.white,
            height: "100%",
            position: "relative",
          }}
        >
          <MessageDetailCard name="Bounougou André" />
          <Box sx={{ p: 3 }}>
            <MessageChatCard text="Bonjour monsieur Nitcheu !" />
            <MessageChatCard text="Bonjour Bounougou André !" isSender />
            <MessageChatCard
              text="Vous voulez faire une offre de placement pour un nouveau Bara ?"
              isSender
            />
            <MessageWriteBar />
          </Box>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={deleteModal}
        onClose={closeDeleteModal}
        title={i18n.t("supprimer")}
        message={i18n.t("supprimer_desc")}
        onConfirm={function (): void {
          throw new Error("Function not implemented.");
        }}
        btn1Text={i18n.t("non")}
        btn2Text={i18n.t("supprimer_ok")}
      />
    </Box>
  );
}

export default Message;
